import * as h2Api from '../../h2Api'

export const IMPORTER_OPEN = 'ADMIN_DATA_IMPORTER_OPEN'
export const IMPORTER_CLOSE = 'ADMIN_DATA_IMPORTER_CLOSE'
export const IMPORTER_LOAD_TYPES = 'ADMIN_DATA_IMPORTER_LOAD_TYPES'
export const SET_DATA_TYPE = 'ADMIN_DATA_SET_TYPE'
export const SET_POSITION = 'ADMIN_DATA_SET_POSITION'
export const COL_TYPE_SELECTED = 'ADMIN_DATA_COL_TYPE_SELECTED'
export const FILE_PARSED = 'ADMIN_DATA_FILE_PARSED'
export const FILTER_VAL_SELECTED = 'FILTER_VAL_SELECTED'
export const DATA_IMPORTED = 'ADMIN_DATA_IMPORTER_IMPORTED'

export const openImporter = () => dispatch => {
  return Promise.resolve(dispatch({ type: IMPORTER_OPEN }))
}

export const closeImporter = () => dispatch => {
  return Promise.resolve(dispatch({ type: IMPORTER_CLOSE }))
}

export const setDataType = tId => dispatch => {
  return Promise.resolve(dispatch({ type: SET_DATA_TYPE, dataType: tId }))
}

export const setStepperPosition = p => dispatch => {
  return Promise.resolve(dispatch({ type: SET_POSITION, step: p }))
}

export const fieldMapSelection = (col, val) => (dispatch, getState) => {
  const mappings = getState().admin.importer.responses.mappings
  const existingCol = Object.keys(mappings).find(key => mappings[key] === val)

  if (existingCol) {
    if (
      confirm(
        `${val} is already selected in column ${existingCol}, do you wish to replace it?`
      )
    ) {
      return Promise.resolve(
        dispatch({ type: COL_TYPE_SELECTED, column: existingCol, dataType: '' })
      ).then(v =>
        Promise.resolve(dispatch({ type: COL_TYPE_SELECTED, column: col, dataType: val }))
      )
    }

    return Promise.resolve(
      dispatch({ type: COL_TYPE_SELECTED, column: col, dataType: mappings[col] })
    )
  }

  return Promise.resolve(
    dispatch({ type: COL_TYPE_SELECTED, column: col, dataType: val })
  )
}

export const filterMapSelection = (col, val) => dispatch => {
  return Promise.resolve(dispatch({ type: FILTER_VAL_SELECTED, id: col, isSet: val }))
}

export const loadTypes = () => {
  return h2Api.get('/admin/importer/types')({
    type: IMPORTER_LOAD_TYPES
  })
}

export const guessAtHeadings = data => (dispatch, getState) => {
  //console.log(data)
  const fields = getState().admin.importer.types.find(
    t => t.id === getState().admin.importer.responses.dataType
  ).fields
  let setAnything = false

  if (data.length > 1) {
    const fRow = data[0]

    fields.forEach((f, idx) => {
      fRow.fieldsRead.forEach((f2, idx2) => {
        if (
          f2.toLowerCase() === f.name.toLowerCase() ||
          (f.aliases || []).includes(f2.toLowerCase())
        ) {
          dispatch(fieldMapSelection(idx2, f.id))
          setAnything = true
        }
      })
    })
  }

  if (setAnything) {
    dispatch(filterMapSelection('FROW', setAnything))
  }

  return Promise.resolve(setAnything)
}

export const transformFromSource = (source, filter, mappings) => {
  const newSource = filter.FROW ? source.slice(1, source.length) : source

  return newSource.map(s => {
    const myObj = {}

    Object.keys(mappings).forEach(k => {
      myObj[mappings[k]] = s.fieldsRead[k] ? s.fieldsRead[k].trim() : null
    })

    return myObj
  })
}

export const uploadData = input => {
  //console.log(input)
  const data = new FormData()

  data.append('file', input.files[0])

  return h2Api.postFile(
    '/admin/importer/upload',
    data
  )({
    type: FILE_PARSED
  })
}

export const performImport = () => (dispatch, getState) => {
  //console.log("importing")
  const importer = getState().admin.importer
  const data = {
    data: transformFromSource(
      importer.loadedData,
      importer.responses.filters,
      importer.responses.mappings
    ),
    filters: importer.responses.filters
  }

  return dispatch(
    h2Api.post(
      `/admin/importer/import/${importer.responses.dataType}`,
      data
    )({ type: DATA_IMPORTED })
  )
}
